import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ISitefinityConfiguration } from 'src/app/model/sitefinity/sitefinitySettings';
import { IDashboard } from 'src/app/model/sitefinity/IDashboard';
import { IFileAClaim } from 'src/app/model/sitefinity/IFileAClaim';

export interface ISitefinityContentSettings {
  sitefinityConfiguration: ISitefinityConfiguration | null;
  
   DashboardPage: IDashboard | null;
  
   FileAClaimPage: IFileAClaim | any;
}

/**
 * @deprecated This class should no longer be used for new development. Please find
 * alternative places to add your code to. This class was used to access Sitefinity
 * content that was set up in the old way PGH did Sitefinity where each page had its
 * own content type / module in Sitefinity. Our current direction is to move away
 * from that and instead use the "Portal Content", "Portal Menus", "Portal Resources",
 * "Portal Settings", etc... to input content into Sitefinity. So we shouuldn't use
 * this class anymore.
 */
@Injectable({
  providedIn: 'root'
})
export class SitefinityContentService {
  settings: Observable<Readonly<ISitefinityContentSettings>>;

  private _initialSettings = {
    sitefinityConfiguration: null,
    DashboardPage: null,
    FileAClaimPage: null,
  };
  
  private settingsSource: BehaviorSubject<ISitefinityContentSettings> = new BehaviorSubject<ISitefinityContentSettings>(this._initialSettings);

  constructor(
  ) {
    this.settings = this.settingsSource.asObservable();
  }

  setSettings(settings: Partial<ISitefinityContentSettings>) {
    const updatedConfig = { ...this.settingsSource.value, ...settings };

    this.settingsSource.next(updatedConfig);
  }

  getSettings(): Readonly<ISitefinityContentSettings> {
    return this.settingsSource.value;
  }
}
